import { type VariantProps } from 'class-variance-authority';
import { FIELD_VARIANT } from '@avanta/shared/constants/forms';
import { cn } from '@avanta/shared/utils/cn';
import { type inputVariants } from '../../../Input/styles';
import {
  dropdownCommandItem,
  dropdownContentBase,
  dropdownTriggerAppearance,
  dropdownTriggerEdit,
} from '../../../styles/dropdown';

export const countrySelectTrigger = (
  variant?: VariantProps<typeof inputVariants>['variant']
): string =>
  cn(
    dropdownTriggerAppearance,
    'gap-1 rounded-s-[8px] rounded-e-none border-r-0 pl-3 pr-2',
    variant === FIELD_VARIANT.EDIT && dropdownTriggerEdit,
    variant === FIELD_VARIANT.INVALID && [
      'bg-red-100 border-red-400',
      'data-[has-value=true]:bg-red-100 data-[has-value=true]:border-red-400',
    ],
    'disabled:pointer-events-none disabled:bg-gray-100 disabled:border-gray-200 disabled:text-gray-300'
  );

export const countrySelectReadOnlyTrigger =
  'cursor-default border-teal-300 bg-mint-100 text-denim-800';

export const countrySelectContent = cn(
  dropdownContentBase,
  'origin-[--radix-popover-content-transform-origin] p-0',
  'w-72 min-w-(--radix-popover-trigger-width)'
);

export const countrySelectItem = dropdownCommandItem;

export const countrySelectScrollArea = 'h-72';
